import {
  MainMenuItem,
  MainMenuItemWrapper,
  ProfileImagePlaceholder,
} from 'components';
import { ROUTES } from 'configs';
import React, { FC } from 'react';

import { NotificationDot, StyledBlock } from './styled';

interface MainMenuUserItemProps {
  image?: string;
  hasNotifications?: boolean;
}

const MainMenuUserItem: FC<MainMenuUserItemProps> = ({
  image,
  hasNotifications = false,
}) => (
  <MainMenuItemWrapper to={ROUTES.PROFILE}>
    <StyledBlock>
      {image ? (
        <MainMenuItem image={image} />
      ) : (
        <ProfileImagePlaceholder width="40px" />
      )}
      {hasNotifications ? <NotificationDot aria-hidden /> : null}
    </StyledBlock>
  </MainMenuItemWrapper>
);

export default MainMenuUserItem;
